import React from 'react';

const LayoutContainer = ({children}) =>{
    return(
        <div className="container">{children}</div>
    );
};

export default LayoutContainer;